var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{ref:"fileRefs",staticClass:"upload-demo",attrs:{"action":"none","accept":".xls,.xlsx","show-file-list":false,"http-request":_vm.fileRequestBackId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }